import { ColumnConfig, ColumnConfigOptions, SimplePortfolioExtractorConfig, StoreLodashExtractor, TabConfig } from '@ddt-web/data-service';

import { FAMILY_COLUMN_CONFIG } from './family-column.config';

export const FAMILY_PERFORMANCE_COMMENTARY = new TabConfig(
	'family.performance.commentary',
	null,
	new SimplePortfolioExtractorConfig(
		null,
		[
			ColumnConfig.create({
				id: 'commentaryTypeRef',
				extractor: new StoreLodashExtractor(['families'], 'commentaryTypeRef')
			} as ColumnConfigOptions<StoreLodashExtractor>)
		],
		FAMILY_COLUMN_CONFIG
	)
);
